/* Derman cart drawer (copy of the lynae.co cart drawer). Replaces the Dawn drawer script.
   Public API kept for the product page: cart-drawer.renderContents(addToCartResponse), .open(), .close(), .classList 'is-empty'. */
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.busy = false;
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (e) => this.onClick(e));
    this.addEventListener('change', (e) => this.onChange(e));
    this.addEventListener('keydown', (e) => {
      if (e.target.matches && e.target.matches('[data-dm-qty]') && e.key === 'Enter') {
        e.preventDefault();
        e.target.blur();
      }
    });
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.activeElement = triggeredBy;
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
    if (this.activeElement && this.activeElement.focus) this.activeElement.focus();
  }

  get root() {
    return window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  }

  onClick(e) {
    const t = e.target;
    if (t.id === 'CartDrawer-Overlay' || t.closest('[data-dm-close]')) return this.close();
    const row = t.closest('.dm-cart-item');
    if (!row) return;
    const line = +row.dataset.line;
    const qty = +row.dataset.qty;
    if (t.closest('[data-dm-remove]')) return this.update(row, 0);
    if (t.closest('[data-dm-dec]')) return qty > 1 ? this.update(row, qty - 1) : null;
    if (t.closest('[data-dm-inc]')) return row.dataset.gift === 'true' ? null : this.update(row, qty + 1);
  }

  onChange(e) {
    const input = e.target;
    if (!input.matches || !input.matches('[data-dm-qty]')) return;
    const row = input.closest('.dm-cart-item');
    let v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = +row.dataset.qty;
    if (row.dataset.gift === 'true') v = Math.min(v, 1);
    if (v !== +row.dataset.qty) this.update(row, v);
    else input.value = row.dataset.qty;
  }

  setLoading(on) {
    this.busy = on;
    this.classList.toggle('dm-cart--loading', on);
    const sp = this.querySelector('.dm-cart__checkout-button-spinner');
    if (sp) sp.style.display = on ? 'inline-block' : 'none';
  }

  post(url, body) {
    return fetch(this.root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
  }

  async update(row, quantity) {
    if (this.busy) return;
    this.setLoading(true);
    try {
      const res = await this.post('cart/change.js', { id: row.dataset.key, quantity: quantity });
      if (res && res.status && res.description) this.showError(res.description);
      else await this.syncGifts(res);
    } catch (err) {
      /* fall through to re-render */
    }
    await this.refresh();
    this.setLoading(false);
  }

  /* Gift logic stays the same as on the product page: E-Book from 3 bottles, brush from 5 bottles. */
  async syncGifts(cart) {
    const g3 = +this.dataset.gift3,
      g5 = +this.dataset.gift5;
    if (!cart || !cart.items || !g3 || !g5) return;
    let main = 0;
    const have = {};
    cart.items.forEach((i) => {
      if (i.variant_id === g3 || i.variant_id === g5) have[i.variant_id] = i;
      else main += i.quantity;
    });
    const want = {};
    want[g3] = main >= 3;
    want[g5] = main >= 5;
    for (const id of [g3, g5]) {
      if (!want[id] && have[id]) await this.post('cart/change.js', { id: have[id].key, quantity: 0 });
      if (want[id] && !have[id] && main > 0) await this.post('cart/add.js', { items: [{ id: id, quantity: 1 }] });
    }
  }

  showError(msg) {
    const el = this.querySelector('[data-dm-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
  }

  async refresh() {
    const res = await fetch(this.root + '?sections=cart-drawer,cart-icon-bubble').then((r) => r.json());
    this.render(res);
  }

  render(sections) {
    const cartCount = sections['cart-drawer'] ? new DOMParser().parseFromString(sections['cart-drawer'], 'text/html') : null;
    if (cartCount) {
      const fresh = cartCount.querySelector('cart-drawer');
      const target = this.querySelector('#CartDrawer');
      const src = cartCount.querySelector('#CartDrawer');
      if (target && src) target.innerHTML = src.innerHTML;
      this.classList.toggle('is-empty', fresh ? fresh.classList.contains('is-empty') : false);
      if (fresh) {
        this.dataset.gift3 = fresh.dataset.gift3;
        this.dataset.gift5 = fresh.dataset.gift5;
      }
    }
    if (sections['cart-icon-bubble']) {
      const b = document.getElementById('cart-icon-bubble');
      const s = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (b && s) b.innerHTML = s.innerHTML;
    }
  }

  renderContents(parsedState) {
    this.classList.remove('is-empty');
    if (parsedState && parsedState.sections) this.render(parsedState.sections);
    setTimeout(() => this.open());
  }
}

customElements.define('cart-drawer', CartDrawer);
